import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Sft from '../Languages/assets/sftdev.png'
import Db from '../Languages/assets/Database.jfif'
import Che from '../Languages/assets/Che.png'
import Csa from '../Languages/assets/Csa.jpg'
import Cna from '../Languages/assets/Cna.jpg'
import Wd from '../Languages/assets/Wd.jpg'
import Pm from '../Languages/assets/Pm.jpg'
import Csb from '../Languages/assets/Csb.jfif'
import Cd from '../Languages/assets/Cd.png'
import Afpb from '../Languages/assets/Afpb.cms'
import Om from '../Languages/assets/Om.png'
import Wde from '../Languages/assets/Wde.png'
import Su from '../Languages/assets/Su.jpg'
import Ms from '../Languages/assets/Ms.jpeg'
import Ts from '../Languages/assets/Ts.jpg'
import Ppl from '../Languages/assets/Ppl.jpg'
import Pcb from '../Languages/assets/Pcb.jpg'
const Radmap_design = () => {
    return (
        <div>
            <h1>Top Careers after Computer Science Engineering (CSE)</h1>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Sft}/> </div>
    <div class="card_title title-white">
      <p>Software Developer</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Software Developer'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Db} />
      </div>
    <div class="card_title title-white">
      <p>Database Administrator</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Daatabase Administrator'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Che} />
    </div>
    <div class="card_title">
        <p>Computer Hardware Engineer</p>
        <NavLink to='/category/Roadmaps for differnt carrers/Computer hardware engineer'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Csa} />
      </div>
    <div class="card_title title-black">
      <p>Computer Systems Analyst</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Computer System Analyst'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Cna} /> </div>
    <div class="card_title title-white">
      <p>Computer Network Architect</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Computer Network Architect'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Wd} />
      </div>
    <div class="card_title title-white">
      <p>Web Developer</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Wev_dev'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Pm} />
    </div>-=
    <div class="card_title">
        <p>Project Manager</p>
        <NavLink to='/category/Roadmaps for differnt carrers/Project Manager'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Csb} />
      </div>
    <div class="card_title title-black">
      <p>Computer Science Blogger</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Computer Science Blogger'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Cd}/> </div>
    <div class="card_title title-white">
      <p>Content Developer</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Content Developer'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Afpb} />
      </div>
    <div class="card_title title-white">
      <p>Author For Programming Books</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Author of Programming books'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Om} />
    </div>
    <div class="card_title">
        <p>Online Marketer</p>
        <NavLink to='/category/Roadmaps for differnt carrers/Online Marketing'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Wde} />
      </div>
    <div class="card_title title-black">
      <p>Web Designer</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Web Designer'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Su} /> </div>
    <div class="card_title title-white">
      <p>Startups</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Startups'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Ms} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Marketing And Sales</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Sales and Marketig'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  
    <div class="card 4">
    <div class="card_image">
      <img src={Ppl} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Professors of programming language</p>
      <NavLink to='/category/Roadmaps for differnt carrers/Professors of programming language'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>

    
    <div class="card 3">
      <div class="card_image"> <img src={Pcb} /> </div>
      <div class="card_title title-white">
        <p>PCB Designer</p>
        <NavLink to='/category/Roadmaps for differnt carrers/PCB Designer'>
      <Button  variant="contained" color="primary" >
            Dive-In
          </Button></NavLink>
      </div>
    </div>
    </div>
    </div>

        
    )
}

export default Radmap_design
